import { useState } from "react";
import { AlertTriangle, CreditCard, LifeBuoy, LogOut } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Subscription } from "@/pages/Settings";
import Support from "@/pages/Support";
import { Button } from "@/components/ui/button";

const COPY = {
  awaiting_payment: ["Payment needed to activate", "Your free trial has ended and full access is limited. Your business data is safe. Billing and Support remain available; subscribe to restore full access."],
  suspended: ["Your NEEC Service subscription requires payment", "Your business data is safe. Update your billing to restore access."],
  cancelled: ["Subscription ended", "Your NEEC Service subscription has ended. Your data is retained. Choose a plan below to resubscribe, or contact NEEC Digital support."],
};

export default function Restricted() {
  const { user, logout } = useAuth();
  const [tab, setTab] = useState("billing");
  const [title, body] = COPY[user.account_status] || COPY.suspended;
  return (
    <div className="min-h-screen bg-[#F8FAFC]" data-testid="restricted-page" data-status={user.account_status}>
      <div className="bg-[#0B192C] text-white px-4 py-5">
        <div className="max-w-3xl mx-auto flex items-start gap-3">
          <AlertTriangle className="text-orange-400 shrink-0 mt-1" size={22} />
          <div className="flex-1 min-w-0"><h1 className="text-xl sm:text-2xl font-bold" data-testid="restricted-title">{title}</h1><p className="text-sm text-slate-300 mt-1">{body}</p></div>
          <Button variant="ghost" className="text-white hover:bg-white/10 shrink-0" onClick={logout} data-testid="restricted-logout"><LogOut size={16} /> <span className="hidden sm:inline">Sign out</span></Button>
        </div>
        <div className="max-w-3xl mx-auto mt-4 flex gap-2">
          {[["billing", "Billing", CreditCard], ["support", "Support", LifeBuoy]].map(([k, l, Icon]) => (
            <button key={k} onClick={() => setTab(k)} data-testid={`restricted-tab-${k}`} className={`inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm font-semibold transition-colors ${tab === k ? "bg-orange-500 text-white" : "bg-white/10 text-slate-200 hover:bg-white/20"}`}><Icon size={15} /> {l}</button>
          ))}
        </div>
      </div>
      <div className="max-w-3xl mx-auto px-4 py-6">
        {tab === "billing" ? <Subscription /> : <Support />}
      </div>
    </div>
  );
}
